import { render, staticRenderFns } from "./ProductChooseWidget.vue?vue&type=template&id=fe9a647c&scoped=true&"
import script from "./ProductChooseWidget.vue?vue&type=script&lang=js&"
export * from "./ProductChooseWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe9a647c",
  null
  
)

export default component.exports